import { render } from "./PendingCasesEdit.vue?vue&type=template&id=3d398fcf"
import script from "./PendingCasesEdit.vue?vue&type=script&lang=js"
export * from "./PendingCasesEdit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/PendingCasesEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d398fcf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d398fcf', __exports__)) {
    console.log('reload')
    api.reload('3d398fcf', __exports__)
  }
  
  module.hot.accept("./PendingCasesEdit.vue?vue&type=template&id=3d398fcf", () => {
    console.log('re-render')
    api.rerender('3d398fcf', render)
  })

}


export default __exports__